import $ from 'jquery';
import MembershipUtils from './../../shared/Membership';
import './cta.scss';

export default () => {
    const $ctaContainer = $('.product-model-paywall-container');
    const $ctaElement = $ctaContainer.find('.subscribe-link .crux-btn');
    const $signInButton = $ctaContainer.find('.signin');
    const hideElementsMapping = { 'EMAIL': $signInButton, 'PRINT': $signInButton };

    MembershipUtils.hideCtaElement(hideElementsMapping);
    MembershipUtils.changeCtaElementText($ctaElement);
    $ctaContainer.show();
};



// WEBPACK FOOTER //
// ./resources/modules/products/v2_0/components/Cta/index.jsx